<div class="er-side-inner">
  <nav class="er-side-nav">
    <div class="er-side-group" *ngFor="let section of sideMenuSections">
      <div class="er-side-group-label" *ngIf="section.label != 'Overview'">{{ section.label }}</div>
      <ng-container *ngFor="let item of section.items">
        <a *ngIf="item.url=='comingsoon'" (click)="openPopup()" class="er-side-item er-side-item-soon">
          <span class="material-icons er-side-ico">{{ item.icon }}</span>
          <span class="er-side-text">{{ item.title }}</span>
          <span class="er-side-soon">Soon</span>
        </a>
        <a [routerLink]="item.url" routerLinkActive="er-side-active" [routerLinkActiveOptions]="{exact: true}" *ngIf="item.url!='comingsoon'" class="er-side-item">
          <span class="material-icons er-side-ico">{{ item.icon }}</span>
          <span class="er-side-text">{{ item.title }}</span>
        </a>
      </ng-container>
    </div>
  </nav>
</div>
